import * as React from "react";

interface RefProps {
    color?: string;
    size?: number;
}

/**
 * Background icon — three stacked diamond/layer shapes with the bottom layer filled solid.
 */
export const BackgroundIcon = React.forwardRef<SVGSVGElement, RefProps>(
    ({ color = "currentColor", size = 24, ...rest }, ref) => {
        return (
            <svg
                ref={ref}
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather"
                {...rest}
            >
                {/* Top layer - outline only */}
                <polygon points="12,2 2,7 12,12 22,7" fill="none" />
                {/* Middle layer - outline only */}
                <polyline points="2,12 12,17 22,12" fill="none" />
                {/* Bottom layer - filled to represent background */}
                <polyline points="2,17 12,22 22,17" fill={color} />
            </svg>
        );
    }
);

BackgroundIcon.displayName = "BackgroundIcon";
export default BackgroundIcon;
